<template>
  <div class="yangbanshezhiBox">
    <div key="yangbanshezhi" class="yangbanshezhi">
      <div class="screenRow">
        <span>专业：</span>
        <el-select v-model="value" filterable placeholder="请选择" size="small" class="querySelect" clearable
          @change="queryagnben">
          <el-option v-for="item in options" :key="item.id" :label="item.cnName" :value="item.id"
            @change="queryagnben">
          </el-option>
        </el-select>
        <el-input v-model="input1" size="small" placeholder="请输入文件名称" prefix-icon="el-icon-search" class="queryInput"
          clearable @input="changeinput">
        </el-input>
        <el-button v-if="addTemplate" type="primary" size="small" @click="addyangban">添加样版</el-button>
        <el-button v-if="deleTemplate" type="danger" size="small" plain @click="delyangban">删除</el-button>
      </div>
      <div class="tableBox">
        <el-table ref="multipleTable" :data="tableData" border tooltip-effect="dark" empty-text="" height="100%"
          @selection-change="selectChange1">
          <template slot="empty">
            <img :src="zanwu" />
            <p style="font-size:16px;color:#000;">暂无数据</p>
          </template>
          <el-table-column type="selection" align="center"> </el-table-column>
          <el-table-column label="序号" type="index" width="60">
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" label="文件名称" prop="fileName">
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" label="文件大小" prop="fileSize">
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" label="Revit版本" prop="revitVersion">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="depName" align="center" label="所属公司">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="updateDate" align="center" label="修改时间">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="userName" align="center" label="上传人">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="remark" align="center" label="备注">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog v-dialogDrag :visible.sync="professionDialogVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" :before-close="handlePofessionClose" title="添加样板"
      custom-class="profession-dialog" width="900px">
      <span>
        <div class="search-header" style="margin-bottom:10px;">
          专业：
          <el-select v-model="value1" filterable placeholder="请选择" size="small" clearable
            style="vertical-align: bottom;" @change="addyangbantable">
            <el-option v-for="item in options" :key="item.id" :label="item.cnName" :value="item.id"
              @change="addyangbantable">
            </el-option>
          </el-select>
          <el-input v-model="specSearchInput" placeholder="请输入文件名称" style="width:200px;vertical-align: middle;margin-left:10px"
            size="small" clearable @input="addyangbantable">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        <el-table ref="multipleTable" :data="professionData" border tooltip-effect="dark" style="width: 100%" height="210"
          @selection-change="handleSelectionSpecChange">
          <template slot="empty">
            <img :src="zanwu" style="height:100px" />
            <p style="font-size:15px;color:#000;">暂无数据</p>
          </template>
          <el-table-column type="selection" align="center" width="55"> </el-table-column>
          <el-table-column label="序号" type="index" width="60">
          </el-table-column>
          <el-table-column prop="fileName" label="文件名称">
          </el-table-column>
          <el-table-column prop="fileSize" label="文件大小(B)">
          </el-table-column>
          <el-table-column prop="revitVersion" label="Revit版本">
          </el-table-column>
          <el-table-column prop="depName" label="所属公司"> </el-table-column>
          <el-table-column prop="updateDate" label="修改时间">
          </el-table-column>
          <el-table-column prop="userName" label="上传人"> </el-table-column>
          <el-table-column prop="remark" label="备注" width="120">
          </el-table-column>
        </el-table>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="professionDialogVisible = false">取 消</el-button>
        <el-button :disabled="!yangbengou.length" type="primary" size="small" @click="confirmAddSpec">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import requestprj from "@/CommonDP/service/standardPlan-service";
import { mapState } from "vuex";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
export default {
  name: "Yangbanshezhi",
  data() {
    return {

      radio: "",
      prjID: "",
      tableData: [],
      professionData: [],
      professionDialogVisible: false,
      options: [],
      value: "",
      specSearchInput: "",
      input1: "",
      value1: "",
      yangbengou: [],
      yangbengoudel: [],
      zanwu: require("@/CommonDP/assets/暂无数据.png")
    };
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      enterpriseId: state => state.enterprise.enterpriseId
    }),
    addTemplate() {
      return checkPermission(this.$allPerms.SETUP_ADD_TEMPLATE);
    },
    deleTemplate() {
      return checkPermission(this.$allPerms.SETUP_DELE_TEMPLATE);
    }
  },
  watch: {
    prjInfo: {
      deep: true,
      handler: function({ prjId }, oldValue) {
        if (prjId) {
          this.prjID = this.prjInfo.prjId;
        }
      }
    }
  },
  created() {
    this.prjID = this.prjInfo.prjId;
    this.value = "";
    this.input1 = "";
    this.queryagnben();
    this.queryagnbendoc();
  },
  methods: {
    // 勾选样本 删除
    selectChange1(val) {
      this.yangbengoudel = val;
    },
    // 弹筐里 勾选样板添加
    handleSelectionSpecChange(val) {
      this.yangbengou = val;
    },
    // 确定添加样本 按钮
    confirmAddSpec() {
      var arr = [];
      for (var i = 0; i < this.yangbengou.length; i++) {
        var data = {
          specId: this.yangbengou[i].specId,
          fileId: this.yangbengou[i].fileId,
          prjId: this.prjID,
          enterpriseId: this.enterpriseId
        };
        arr.push(data);
      }
      requestprj.revitTemplateSettingadd(arr).then(res => {
        if (res.result === "0") {
          this.$message.success("添加成功");
          this.queryagnben();
          this.professionDialogVisible = false;
        }
      });
    },
    // 关闭样本弹框
    handlePofessionClose() {
      this.professionDialogVisible = false;
    },
    // open 添加样版
    addyangban() {
      this.professionDialogVisible = true;
      this.value1 = "";
      this.specSearchInput = "";
      this.yangbengou = [];
      this.addyangbantable();
    },
    // 样本表格数据
    queryagnben() {
      var data = {
        prjId: this.prjID,
        specId: this.value,
        fileName: this.input1
      };
      requestprj.getRevitTemplateList(data).then(res => {
        if (res.result === "0") {
          this.tableData = res.data;
        }
      });
    },
    // 样板里的专业
    queryagnbendoc() {
      requestprj.getSpecList(this.prjID).then(res => {
        if (res.result === "0") {
          this.options = res.data;
        }
      });
    },
    // 添加样本的表格数据
    addyangbantable() {
      requestprj.getBySpecId(this.specSearchInput, this.value1, this.prjID, this.enterpriseId).then(res => {
        if (res.result === "0") {
          this.professionData = res.data;
        }
      });
    },

    changeinput() {
      this.queryagnben();
    },
    // 样版删除
    delyangban() {
      if (this.yangbengoudel.length) {
        this.$confirm("此操作将删除选中的样本, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            var arr = [];
            for (var i = 0; i < this.yangbengoudel.length; i++) {
              var data = {
                prjId: this.prjID,
                fileId: this.yangbengoudel[i].fileId,
                specId: this.yangbengoudel[i].specId
              };
              arr.push(data);
            }
            requestprj.delete(arr).then(res => {
              if (res.result === "0") {
                this.$message.success("删除成功");
                this.queryagnben();
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      } else {
        this.$message.warning("请选择要删除的样版");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.yangbanshezhiBox {
  width: 100%;
  height: 100%;
  .yangbanshezhi {
    height: 100%;
    display: flex;
    flex-direction: column;
    .screenRow{
      display: flex;
      align-items: center;
    }
    .querySelect {
      width: 207px;
      margin-right: 12px;
      vertical-align: bottom;
    }
    .queryInput {
      width: 192px;
      margin-right: 10px;
      vertical-align: middle;
    }
    .tableBox {
      margin-top: var(--middle-space);
      height: 1px;
      flex-grow: 1;
    }
  }
}
</style>
